import { inventoryField } from '../shared/array-types.js';
import { encounterShapeValue } from '../janus-engine/inventory/mesh-scale.js';
import type { HunkerObject } from '../janus-engine/actions/hunker.js';
import { footprintInputs, restRow } from './inventory-floor-move-truth.js';
type Row = Record<string, unknown>;
const upper = (v: unknown) => String(v ?? '').toUpperCase();
export function heldHunkerObject(encounter: Row, objectId?: string): HunkerObject | null {
  if (!objectId) return null;
  const object = (encounter.encounter_inventories_arr as Row[] | undefined)?.find(row => upper(inventoryField(row, 'inventory_id')) === upper(objectId));
  if (!object) return null;
  let shape = encounterShapeValue(encounter);
  if (typeof shape === 'string') { try { shape = JSON.parse(shape); } catch { shape = null; } }
  return { object, footprint: footprintInputs(encounter, object), shape: shape as HunkerObject['shape'],
    supportRows: function* () {
      for (const row of encounter.encounter_inventories_arr as Row[] ?? [])
        if (Number(inventoryField(row, 'inventory_deleted') ?? 0) === 0) yield restRow(encounter, row);
    } };
}
